import {WithoutSummaryModel} from '../../../../../common/entity/dto/plain/withoutSummary.model';
import {Scanner3dModel} from '../../../common/api/entity/scanner3d.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';

export class Scanner3dAccountAgentConfigurationModel extends WithoutSummaryModel{
    withSound: boolean;
    lightSensibility: string;
    countdown: number;
    url: string;
    inApp: boolean;
}
